import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import IndexPage from '../../product-updates/components/IndexPage';
import ErrorBoundary from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Paths = {
  HOME: '/new-to-you'
};
export const Routes = () => {
  const {
    search
  } = useLocation();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/:category",
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        componentName: "IndexPage",
        children: /*#__PURE__*/_jsx(IndexPage, {})
      })
    }), /*#__PURE__*/_jsx(Redirect, {
      to: `${Paths.HOME}${search}`
    })]
  });
};